// Mock data for the physiotherapy clinic website
export const mockData = {
  hero: {
    title: "Expert Physiotherapy and Wellness Care",
    subtitle: "Restoring movement, relieving pain, and uplifting lives",
    buttonText: "Book Appointment",
    backgroundImage:
      "https://images.unsplash.com/photo-1732376800702-c555160a4f21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxtZWRpY2FsJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzUzNDYyNzU2fDA&ixlib=rb-4.1.0&q=85",
  },

  carousel: [
    {
      id: 1,
      image:
        "/ModernFac.webp",
      title: "Modern Facility",
      description: "State-of-the-art treatment rooms",
    },
    {
      id: 2,
      image:
        "/ExpCare.webp",
      title: "Professional Treatment",
      description: "Expert care for every patient",
    },
    {
      id: 3,
      image:
        "/SpecializedCare.webp",
      title: "Specialized Care",
      description: "Personalized treatment plans",
    },
    {
      id: 4,
      image:
        "/Rehab.webp",
      title: "Rehabilitation",
      description: "Comprehensive recovery programs",
    },
    {
      id: 5,
      image:
        "/ComfortCare.webp",
      title: "Comfort & Care",
      description: "Relaxing environment for healing",
    },
  ],

  highlights: [
    {
      id: 1,
      title: "22+ Years of Expertise",
      icon: "🏆",
      description: "Decades of professional experience",
    },
    {
      id: 2,
      title: "Multiple Awards",
      icon: "⭐",
      description: "Recognized for excellence in care",
    },
    {
      id: 3,
      title: "Thousands of Success Stories",
      icon: "💙",
      description: "Proven track record of healing",
    },
    {
      id: 4,
      title: "Trusted by Professionals",
      icon: "🎯",
      description: "Leaders and athletes choose us",
    },
  ],

  services: [
    {
      id: 1,
      title: "Sports Injury Recovery",
      description: "Specialized treatment for athletes and active individuals",
      icon: "🏃",
      color: "from-blue-500 to-blue-700",
    },
    {
      id: 2,
      title: "Pain Relief & Management",
      description: "Comprehensive solutions for chronic and acute pain",
      icon: "🌟",
      color: "from-teal-500 to-teal-700",
    },
    {
      id: 3,
      title: "Chiropractic Care",
      description: "Expert spinal adjustment and musculoskeletal treatment",
      icon: "🦴",
      color: "from-blue-600 to-blue-800",
    },
    {
      id: 4,
      title: "Rehabilitation",
      description: "Complete recovery programs for post-injury care",
      icon: "⚡",
      color: "from-slate-500 to-slate-700",
    },
    {
      id: 5,
      title: "Customized Wellness Programs",
      description: "Personalized health and fitness optimization",
      icon: "💪",
      color: "from-blue-500 to-blue-700",
    },
  ],

  branches: [
    {
      id: 1,
      name: "Gajuwaka Branch",
      address: "123 Main Street, Medical District, City 12345",
      phone: "+91 92810 10745",
      hours:
        "Mon-Sat: 09:00 AM to 09:00 PM\nSun: 09:00 AM to 05:00 PM",
      mapUrl: "https://maps.app.goo.gl/oroUFYBCagUcDQxi9",
    },
    {
      id: 2,
      name: "Kurmannapalem Branch",
      address: "Duvvada Rd, Kurmannapalem, Visakhapatnam",
      phone: "+91 84999 61352",
      hours:
        "Mon-Sat: 09:00 AM to 09:00 PM\nSun: 09:00 AM to 05:00 PM",
      mapUrl: "https://maps.app.goo.gl/erb5vjvPMDwTmawFA",
    },
  ],

  testimonials: [
  {
    id: 1,
    name: "Sravan",
    content:
      "After my ACL surgery, I thought recovery would take forever, but Dr. Harish Jasti helped me heal fast and regain mobility in just a few months.",
    rating: 5,
  },
  {
    id: 2,
    name: "R. Sathi Babu",
    content:
      "I underwent surgery for my rotatory cuff injury. Dr. Jasti’s expertise and the physiotherapy team’s care helped me recover fully and comfortably.",
    rating: 5,
  },
  {
    id: 3,
    name: "T.V. Ramana",
    content:
      "After my knee injury, I had very limited motion. With 3 months of physiotherapy at VPJC, my knee regained 140° movement. Dr. Harish is truly amazing!",
    rating: 5,
  },
  {
    id: 4,
    name: "Manikanta",
    content:
      "I had a tibia fracture with foot drop. After 3 months of physiotherapy under Dr. Harish, I regained full function and could walk normally. Excellent care!",
    rating: 4,
  },
  {
    id: 5,
    name: "Sandeep",
    content:
      "Visakha Physiotherapy & Jasti Chiropractic helped me recover from Bell’s Palsy within 3 months. My facial movement is fully restored.",
    rating: 5,
  },
  {
    id: 6,
    name: "Prasad",
    content:
      "I had an ankle fracture and struggled with rehabilitation elsewhere. VPJC’s physiotherapy helped me recover fully in just 3 months. Highly recommended!",
    rating: 4,
  },
  {
    id: 7,
    name: "G. Navaratnam",
    content:
      "I was suffering from chronic low back pain. After physiotherapy at VPJC, my pain is completely gone. Excellent treatment and care!",
    rating: 4,
  },
  {
    id: 8,
    name: "Ch. Ayyappa Kumar",
    content:
      "The best decision I made was visiting VPJC for my sciatica. The staff was professional, supportive, and the results were outstanding.",
    rating: 4,
  },
  {
    id: 9,
    name: "Sneha Priya",
    content:
      "My child had Erb’s Palsy at birth. After physiotherapy at VPJC from day 21, she completely recovered in four months. The team’s care is exceptional.",
    rating: 4,
  },
],



  doctors: [
    {
      id: 1,
      name: "Dr. Alexandra Sterling",
      credentials: "M.P.T., B.P.T., M.I.A.P.",
      specialization: "Sports Medicine & Rehabilitation",
      experience: "15+ years",
      image:
        "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=300&h=300&fit=crop&crop=face",
      bio: "Specializes in sports injury recovery and performance optimization with extensive experience treating professional athletes.",
    },
    {
      id: 2,
      name: "Dr. Marcus Thompson",
      credentials: "M.P.T., D.P.T., O.C.S.",
      specialization: "Orthopedic Physical Therapy",
      experience: "12+ years",
      image:
        "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=300&h=300&fit=crop&crop=face",
      bio: "Expert in orthopedic conditions and post-surgical rehabilitation with a focus on restoring optimal function.",
    },
    {
      id: 3,
      name: "Dr. Rachel Kim",
      credentials: "M.P.T., B.P.T., C.M.T.",
      specialization: "Pain Management & Manual Therapy",
      experience: "18+ years",
      image:
        "https://images.unsplash.com/photo-1594824506867-1d4f1b6e5a8c?w=300&h=300&fit=crop&crop=face",
      bio: "Specializes in chronic pain management and advanced manual therapy techniques for complex conditions.",
    },
  ],

  awards: [
    {
      id: 1,
      title: "Excellence in Patient Care Award",
      year: "2024",
      organization: "National Healthcare Excellence Foundation",
      description:
        "Recognized for outstanding patient satisfaction and clinical outcomes",
    },
    {
      id: 2,
      title: "Best Physiotherapy Clinic",
      year: "2023",
      organization: "Regional Medical Association",
      description: "Awarded for innovative treatment methods and patient care",
    },
    {
      id: 3,
      title: "Innovation in Rehabilitation",
      year: "2023",
      organization: "Physical Therapy Excellence Board",
      description: "Recognition for pioneering rehabilitation techniques",
    },
    {
      id: 4,
      title: "Top Workplace in Healthcare",
      year: "2022",
      organization: "Healthcare Leadership Council",
      description:
        "Honored for exceptional work environment and team excellence",
    },
  ],

  contact: {
    phone: "+91 92810 10745",
    email: "contact@jastiphysiochiro.com",
    emergencyPhone: "+91 92810 10745",
    address: "123 Main Street, Medical District, City 12345",
  },
};
